/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Retention_8Inputs */

const da_privacy_retention_8 = /** @type {(inputs: Privacy_Retention_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log over udsendte e-mails (modtager, slags og om de blev sendt): 60 dage.`)
};

/** @type {(inputs: Privacy_Retention_8Inputs) => LocalizedString} */
const en_privacy_retention_8 = da_privacy_retention_8;

/**

* @param {Privacy_Retention_8Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_retention_8 = /** @type {((inputs?: Privacy_Retention_8Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Retention_8Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_retention_8(inputs)
	return /** @type {LocalizedString} */ ("Log over udsendte e-mails (modtager, slags og om de blev sendt): 60 dage.")
});